module.exports = __webpack_public_path__ + "img/bg_math_04.8c97e805.jpg";